// extracted by mini-css-extract-plugin
module.exports = {"text":"SectionWithBoxes-module__text___JBvL4","boxes":"SectionWithBoxes-module__boxes___3D5K8"};